module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Getting Started","pageDesc":"Getting Started","mantra":"Getting Started","installation":"Installation","included":"What\u0027s included","github":"GitHub Repo"},"ar":{"pageTitle":"ابدأ الآن","pageDesc":"ابدأ الآن","mantra":"ابدأ الآن","installation":"التثبيت","included":"ما يتضمنه!","github":"غيت هاب"}}')
  delete Component.options._Ctor
}
